import './panel-header.scss';
import { useState, useMemo } from 'react';
import Tab from '../types/tab';
import {
    formatDistrictAreaKm2,
    formatDistrictTurnover,
    formatDistrictFrequencyAndVisitTime
} from './district-data-format';
import PanelByline from './PanelByline';
import ScbStats from './ScbStats';
import Skeleton from '../../skeleton/Skeleton';
import classNames from 'classnames';
import { countActiveFilters } from '../helpers/filters/filter-helpers';

const PanelHeader = ({
    district,
    type,
    onSetActiveTab,
    onOpenEdit,
    hideFilterButton = false,
    demographicsLayerSelection = [],
    demographicsDistrictId = null,
    compact = false,
    salesDistrictFilters = null,
    isLoading = false
}) => {
    const districtName = district?.name || '';
    const [showMore, setShowMore] = useState(false);
    const activeFilterCount = useMemo(() => countActiveFilters(salesDistrictFilters), [salesDistrictFilters]);
    return (
        <div className={classNames({
            'panel-header': true,
            'panel-header--compact': compact
        })}>
            {!compact && (
                <header className="panel-header__title-container">
                    <div>
                        <PanelByline text="Distrikt" />
                        <h1 className="panel-header__title">
                            {isLoading
                                ? <Skeleton variant="circular" width="20px" height="20px" />
                                : <span className="panel-header__district-color" style={{ backgroundColor: district?.color }}></span>
                            }
                            {isLoading
                                ? <Skeleton width="120px" height="22px" />
                                : <span>{districtName || ''}</span>
                            }
                            {!isLoading && district && !hideFilterButton && 
                                <button type="button" className="panel-header__edit-button" onClick={onOpenEdit}><span>Ändra namn och färg</span></button>
                            }
                        </h1>
                    </div>
                    {!hideFilterButton && !isLoading && (
                        <button type="button" className="panel-header__filter-button" onClick={() => onSetActiveTab(Tab.FILTER)}>
                            {type === 'foodservice' ? 'Filtrera enheter' : 'Filtrera butiker'}
                            {activeFilterCount > 0 && <span className="panel-header__filter-badge">{activeFilterCount}</span>}
                        </button>
                    )}
                </header>
            )}
            <ul className="panel-header__data">
                {!compact && (
                <li>
                    <h3 className="panel-header__data-heading panel-header__data-heading--area">Distriktsarea</h3>
                    <span className="panel-header__data-value">
                        {isLoading ? <Skeleton width="80px" /> : formatDistrictAreaKm2(district?.salesDistrictArea)}
                    </span>
                </li>
                )}
                <li>
                    <h3 className="panel-header__data-heading panel-header__data-heading--units">Antal valda {type === 'foodservice' ? 'enheter' : 'butiker'}</h3>
                    <span className="panel-header__data-value">
                        {isLoading ? <Skeleton width="40px" /> : (district && district.numberOfHits) || 0}
                    </span>
                </li>
                {!compact && type !== 'foodservice' && (
                    <li>
                        <h3 className="panel-header__data-heading panel-header__data-heading--turnover">Omsättning</h3>
                        <span className="panel-header__data-value">
                            {isLoading ? <Skeleton width="100px" /> : formatDistrictTurnover(district?.turnOver)}
                        </span>
                    </li>
                )}
                {type !== 'foodservice' && (
                <li>
                    <h3 className="panel-header__data-heading panel-header__data-heading--frequency">Frekvens / Besökstid</h3>
                    <span className="panel-header__data-value">
                        {isLoading ? <Skeleton width="100px" /> : formatDistrictFrequencyAndVisitTime(district?.frequency, district?.vistingTimeHours)}
                    </span>
                </li>
                )}
            </ul>
            {showMore && !hideFilterButton && (
                <ScbStats
                    districtId={demographicsDistrictId}
                    layerSelection={demographicsLayerSelection}
                />
            )}
            {!hideFilterButton && (
                <button type="button" className={classNames({
                    'panel-header__show-more-button': true,
                    'panel-header__show-more-button--open': showMore
                })} onClick={() => setShowMore(!showMore)}>{showMore ? 'Visa mindre' : 'Visa mer'}</button>
            )}
        </div>
    );
};

export default PanelHeader;